import styled from 'styled-components'

export const CustomForm = styled.form`
    height: auto;
    max-width: auto;

    .textInput > span {
        white-space: normal;
    }
`
